import React from 'react';

import { Typography } from '@components/atoms/Typography';

export const StartStepsSection: React.FC = () => {
  return (
    <section className="w-full max-w-2xl mb-4">
      <Typography
        textKey="AstroPayDownload.stepsTitle"
        variant="h3"
        weight={500}
        className="text-[20px] text-center mb-4"
      />
      <ol className="list-decimal list-inside text-left text-sm text-gray-700 font-semibold space-y-2">
        <li>
          <Typography textKey="AstroPayDownload.step1Prefix" variant="span" weight={600} />{' '}
          <Typography textKey="AstroPayDownload.step1" variant="span" weight={400} />
        </li>
        <li>
          <Typography textKey="AstroPayDownload.step2Prefix" variant="span" weight={600} />{' '}
          <Typography textKey="AstroPayDownload.step2" variant="span" weight={400} />
        </li>
        <li>
          <Typography textKey="AstroPayDownload.step3Prefix" variant="span" weight={600} />{' '}
          <Typography textKey="AstroPayDownload.step3" variant="span" weight={400} />
        </li>
      </ol>
    </section>
  );
};
